import { render } from "./Modal.vue?vue&type=template&id=4aff3cc9"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
script.render = render

export default script